import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'frontend-pagination-type-three',
  templateUrl: './pagination-type-three.component.html',
  styleUrls: ['./pagination-type-three.component.scss'],

  standalone: false,
})
export class PaginationTypeThreeComponent implements OnChanges {
  @Input() classes; // for example 'pg-blue justify-content-center'
  @Input() loading;
  @Input() meta;
  @Input() links;
  @Input() lastPage; // so we can detect changes
  @Input() simplified : boolean; // just previous and next with item numbers
  @Output() changePage = new EventEmitter<number>();

  pageList;

  constructor() { }


  clickPage = function (newPage){
    if (this.loading){return};
    this.changePage.emit(newPage);
  };
  buildPageList = function (){
      this.pageList = Array.from(Array(this.meta.last_page).keys()).map((x,index)=>index+1);
  };

  ngOnChanges (changesObject) {
      if (changesObject.lastPage && changesObject.lastPage.currentValue){
          this.buildPageList();
      };
  };

}
